import { formLookup } from "./forms/index.js";

(async function () {
	const forms = document.querySelectorAll<HTMLDivElement>(
		".rt-form-bridge-form",
	);
	for (const form of forms) {
		if (!form.dataset.id) {
			throw new Error("Form ID not found");
		}
		const id = form.dataset.id;
		if (!(id in formLookup)) {
			throw new Error("Form not found");
		}
		const definition = formLookup[id];
		const { init } = await import(`./front/app.js`);
		init(definition, form);
	}

	const preferenceForms = document.querySelectorAll<HTMLDivElement>(
		".rt-form-bridge-preferences",
	);
	for (const form of preferenceForms) {
		const idHash = form.dataset.id;
		if (!idHash) {
			throw new Error("User ID not found");
		}
		const email = form.dataset.email;
		if (!email) {
			throw new Error("Email not found");
		}

		const { init } = await import(`./front/preferences/index.js`);
		init(form, { email, idHash });
	}
})();
